
const BusinessCategoriesIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
       <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M14.168 17.785H5.832a3.335 3.335 0 0 1-3.335-3.335V7.782c0-.92.746-1.667 1.667-1.667h11.672c.92 0 1.667.746 1.667 1.667v6.67a3.335 3.335 0 0 1-3.335 3.334Z"
            clipRule="evenodd"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M6.665 6.114V4.446c0-.92.747-1.667 1.668-1.667h3.334c.921 0 1.668.746 1.668 1.667v1.668"
            />
        <rect
            width={3.335}
            height={2.501}
            x={8.333}
            y={9.448}
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            rx={0.5}
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M11.668 10.699h2.917a2.918 2.918 0 0 0 2.918-2.918v0M8.333 10.699H5.415A2.918 2.918 0 0 1 2.497 7.78v0"
        />
    </svg>
)

export default BusinessCategoriesIcon
